module.exports = __webpack_public_path__ + "static/MindBody-8b60665b410e813e7553e9ce1d0f5af0.svg";